import {Component, OnInit, TemplateRef} from '@angular/core';
import {BlockStatementAbstractComponent} from '../block-statement-abstract.component';

@Component({
    selector: 'core-block-company-promise',
    templateUrl: './block-company-promise.component.html',
    standalone: false
})
export class BlockCompanyPromiseComponent extends BlockStatementAbstractComponent implements OnInit {
    companyPromises: any;

    override ngOnInit(): void {
        super.ngOnInit();
        this.companyPromises = this.trsService.getCompanyPromise();
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService!.show(template);
    }
}
